export const range = (end) =>
    Array.from(
        (function* () {
            let start = 0
            while (start < end) yield start++
        })()
    )
